// // @flow
import { takeEvery, put, select } from 'redux-saga/effects';

import { DEFAULT_SOCKET_ROLE } from '../settings';
import { RPS_JOIN_TO_CHANNEL_REQUIRED } from '../types/socket';
import * as selectors from '../reducers';
import * as actions from '../actions/socket';


function* joinChannel(action) {
  const { channelId, requireAuth = true } = action.payload;
  const token = yield select(selectors.getToken);
  const id = yield select(selectors.getUserId);

  if (requireAuth) {
    yield put(actions.join(id, token, DEFAULT_SOCKET_ROLE, channelId));
  } else {
    yield put(actions.join(undefined, undefined, DEFAULT_SOCKET_ROLE, channelId));
  }
}

export function* watchJoinChannelRequired(): Iterator<any> {
  yield takeEvery(
    RPS_JOIN_TO_CHANNEL_REQUIRED,
    joinChannel,
  );
}



// WEBPACK FOOTER //
// ./src/scripts/sagas/socket.js